import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-company",
  "use": "icon-company-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-company\"><defs><style type=\"text/css\"></style></defs><path d=\"M0 102.4v921.6h665.6V102.4l-153.6-102.4z m384 808.96h-307.2V819.2l307.2-5.12z m0-204.8l-307.2 5.12v-92.16l307.2-20.48z m0-220.16l-307.2 20.48V414.72l307.2-35.84z m0-225.28l-307.2 40.96V204.8l307.2-61.44zM921.6 921.6V102.4l-153.6-102.4h-76.8L768 51.2v972.8h256v-102.4h-102.4z\" p-id=\"22965\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol